import { combineReducers } from 'redux';

import auth from './modules/auth/reducer';
import inicio from './modules/inicio/reducer';
import quantidadeErros from './modules/admin/reducerQuantidadeErros';
import admin from './modules/admin/reducer';
import guiaInterativo from './modules/guiaInterativo/reducer';
import reserva from './modules/reserva/reducer';
import problema from './modules/problema/reducer';
import agenda from './modules/agenda/reducer';
import consumo from './modules/consumo/reducer';
import mudancas from './modules/mudancas/reducer';
import unidade from './modules/unidade/reducer';
import notificacao from './modules/notificacao/reducer';
import registroAcesso from './modules/registroAcesso/reducer';
import calendarioPresenca from './modules/calendarioPresenca/reducer';
import achados from './modules/achados/reducer';

export default combineReducers({
  consumo,
  problema,
  inicio,
  unidade,
  mudancas,
  achados,
  notificacao,
  quantidadeErros,
  auth,
  admin,
  reserva,
  agenda,
  guiaInterativo,
  calendarioPresenca,
  registroAcesso
});



// WEBPACK FOOTER //
// ./src/reducers.js